interface AvatarProps {
  name: string
  src?: string | null
  size?: number
}

export function Avatar({ name, src, size = 28 }: AvatarProps) {
  const style = { width: size, height: size }
  if (src) {
    return <img src={src} alt={`Avatar de ${name}`} style={style} className="rounded-full object-cover" />
  }
  return (
    <span
      style={style}
      className="flex items-center justify-center rounded-full bg-accent text-sm font-extrabold text-[#06101d]"
      aria-hidden
    >
      {(name || '?')[0]?.toUpperCase()}
    </span>
  )
}
